import api from "../../../services/api";

export interface ABCRankingBucket {
  rank: string;
  number_of_sku: number;
  daily_sales_criteria: string;
  percentage: number;
}

export interface ABCRankingStore {
  store: string;
  buckets: ABCRankingBucket[];
}

export const fetchWholesaleABCRanking = async (window_size: number): Promise<ABCRankingStore[]> => {
  const { data } = await api.get<ABCRankingStore[]>("/api/wholesale/sales_reports/abc_ranking", {
    params: { window_size },
  });
  return data;
};